import { render, staticRenderFns } from "./RedirectModal.vue?vue&type=template&id=edb2394a"
import script from "./RedirectModal.vue?vue&type=script&lang=js"
export * from "./RedirectModal.vue?vue&type=script&lang=js"
import style0 from "./RedirectModal.vue?vue&type=style&index=0&id=edb2394a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports